import { Button, DatePicker, Divider, Form } from 'antd'
import React, { useEffect, useRef } from 'react'

import './styles.scss'
import moment from 'moment'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import usePageSettings from '../../../../../hooks/usePageSettings'
import { TAX_PERCENTAGE } from '../../../../../constants/finance'

const FixedTourDateSelection = ({
    userTourData,
    setUserTourData,
    tourPackage,
    messageApi,
    prev,
    next,
    calculateTotal,
    calculateSubTotal,
    calculateDiscount,
    calculateTax,
    current,
}) => {
    const formRef = useRef(null)
    const selectedCurrency = usePageSettings()?.selectedCurrency;

    useEffect(() => {
        window.scrollTo(0, 0)
        if (userTourData.startDate) {
            formRef?.current?.setFieldsValue({
                startDate: moment(userTourData.startDate)
            })
        }
    }, [userTourData.startDate])

    const onDateChange = (date) => {
        date = date ? date.format('YYYY-MM-DD') : null
        setUserTourData({ ...userTourData, startDate: date })
    }

    const getMinDate = () => {
        const today = moment()
        const minDate = today.add(2, 'weeks')
        return minDate
    }

    const getMaxDate = () => {
        const today = moment()
        const maxDate = today.add(1, 'year')
        return maxDate
    }

    const handleGoNext = (values) => {
        if (!userTourData.startDate) {
            messageApi.open({
                type: 'error',
                message: 'Start Date is required',
                description: 'Please select a start date for the tour.',
            })
            return
        }
        next()
    }

    return (
        <div className='dateAndQuantity'>
            <div className='left'>
                <div className='tour_package_details'>
                    <div className='tour_package_details_header'>
                        <h2>{tourPackage?.packageName}</h2>
                        <p>{tourPackage?.durationDays} Days / {tourPackage?.durationNights} Nights</p>
                    </div>
                    <div className='tour_package_details_image'>
                        <LazyLoadImage
                            alt='tour package'
                            effect="blur"
                            wrapperProps={{
                                style: { transitionDelay: "0.1s" },
                            }}
                            src={tourPackage?.thumbnailUrl}
                        />
                    </div>
                </div>

                <div className='pricing_details'>
                    <h3>Pricing Details</h3>
                    <div className='pricing_details_content'>
                        <div className='pricing_row'>
                            <span>Package Price (for {tourPackage?.maxGroupSize} {tourPackage?.maxGroupSize > 1 ? 'people' : 'person'})</span>
                            <span>{calculateSubTotal()} {selectedCurrency || 'AUD'}</span>
                        </div>
                        {tourPackage?.discount > 0 && (
                            <div className='pricing_row discount'>
                                <span>Discount ({tourPackage?.discount}%)</span>
                                <span>- {calculateDiscount()} {selectedCurrency || 'AUD'}</span>
                            </div>
                        )}
                        <div className='pricing_row'>
                            <span>Tax ({TAX_PERCENTAGE}%)</span>
                            <span>{calculateTax()} {selectedCurrency || 'AUD'}</span>
                        </div>
                        <Divider />
                        <div className='pricing_row total'>
                            <span>Total</span>
                            <span>{calculateTotal()} {selectedCurrency || 'AUD'}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className='right'>
                <div className='form_container'>
                    <h2>Select Start Date</h2>
                    <p>Please select your preferred start date for the tour. The tour must be booked at least 2 weeks in advance.</p>

                    <Form
                        layout='vertical'
                        onFinish={handleGoNext}
                        ref={formRef}
                        requiredMark={false}
                    >
                        <Form.Item
                            name='startDate'
                            label='Start Date'
                            rules={[{ required: true, message: 'Please select a start date!' }]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format="YYYY-MM-DD"
                                disabledDate={(current) => {
                                    return current && (current < getMinDate() || current > getMaxDate());
                                }}
                                onChange={onDateChange}
                                placeholder="Select start date"
                            />
                        </Form.Item>

                        <div className='form_actions'>
                            <Button
                                type='primary'
                                htmlType='submit'
                                className='next_btn'
                                size='large'
                            >
                                Continue to Traveler Information
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default FixedTourDateSelection
